module.exports = __webpack_public_path__ + "media/halloween_tipping_tier_4-87e622cb77c04af61328aa46c0735c44.mp3";